export default {
  addOns: 'Adicionales',
  all: 'Todos',
  browse: 'Explorar',
  buyTickets: 'Comprar entradas',
  countSelected: '{{count}} seleccionados',
  joinWaitlist: 'Unirse a la lista de espera',
  joining: 'Uniéndose',
  noDatesAvailable: 'No hay fechas disponibles',
  salesEnded: 'Ventas terminadas',
  schedule: 'Calendario',
  seeMoreDates: 'Ver más fechas',
  soldOut: 'Agotado',
  about: 'Acerca de',
  agenda: 'Agenda',
  menu: 'Menú',
  included: 'Incluido',
  viewMore: 'Ver más',
  viewLess: 'Ver menos',
  location: 'Ubicación',
  time: 'Hora',
  at: 'a',
  noTimesAvailableOnThisDateFotThisPartySize:
    'No hay horarios disponibles en esta fecha para este tamaño de grupo',
  availableTimes: 'Horarios disponibles',
  waitlist: 'Lista de espera',
  continue: 'Continuar',
  tickets: 'Entradas',
  ticketsAreNoLongerAvailable: 'Las entradas ya no están disponibles.',
  checkOutOutOtherExperiences: '¡Descubre nuestras otras experiencias!',
  viewExperiences: 'Ver experiencias',
  from: 'de',
  cancellationPolicy: 'Política de cancelación',
  rsvp: 'RSVP',
  nights: 'noches',
  request: 'Solicitar',
  arrival: 'Llegada',
  departure: 'Salida',
};
